import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-back-component',
  templateUrl: './app-back-component.component.html',
  styleUrls: ['./app-back-component.component.scss']
})
export class AppBackComponentComponent implements OnInit {
  private parent: any;
  private current: any;
  public path: string;

  constructor(private router: ActivatedRoute, private route: Router) {
    this.parent = this.router.parent.snapshot;
    this.current = this.router.snapshot;
    const snapshotRouter = this.router.snapshot.routeConfig;

    // FIX-ME CareerDay

    if (this.current.params && this.current.params.careerDayId) {
      this.path = `career_days/${this.current.params.careerDayId}`;
      return;
    }


    if (typeof this.parent.queryParams['job_id'] !== 'undefined') {
      this.path = 'recruiting/' + this.parent.queryParams['job_id'] + '/curricula/' + (this.parent.queryParams['old_tab'] || '');
    } else if (typeof this.parent.queryParams['job_id'] === 'undefined' && snapshotRouter.path === 'curricula/:applier_id') {
      this.path = 'candidates';
      if (this.parent.queryParams['fromChat']) {
        this.path = 'chat/' + this.parent.queryParams['fromChat'];
      }
    } else if (snapshotRouter.path === ':id/check-ins/:applier_id') {
      this.path = this.parent.routeConfig.path + '/' + this.router.snapshot.params.id +
        '/check-ins';
    } else {
      this.path = this.parent.routeConfig.path;
    }

  }

  ngOnInit() { }

  back() {
    this.route.navigate(['/' + this.path]);
  }

}
